import { z } from 'zod'

export enum AiAutomationScenario {
  INSTANT_ANSWERS = 'faq',
  SOCIAL_ENGAGEMENT = 'social_engagement',
}

export enum AiAutomationTovState {
  GENERATION_IN_PROGRESS = 'generation_in_progress',
  WAITING_USER_REACTION = 'waiting_user_reaction',
  ACTIVE = 'active',
}

const fallbackAssigneeSchema = z
  .object({
    group_id: z.number().nullable(),
    user_id: z.number().nullable(),
  })
  .optional()

const tovSampleSchema = z.object({
  post: z.object({
    id: z.string().nullable(),
    caption: z.string(),
    media_url: z.string().nullable(),
  }),
  comment: z.object({
    id: z.string().nullable(),
    text: z.string(),
    username: z.string().nullable(),
    avatar_url: z.string().nullable(),
  }),
  reply: z.object({
    id: z.string().nullable(),
    text: z.string().nullable(),
  }),
  ai_reply: z.object({
    text: z.string(),
  }),
})

const aiAutomationConfigSchema = z.object({
  scenarios: z.object({
    faq: z.object({
      published: z.boolean(),
      fallback_assignee: fallbackAssigneeSchema,
    }),
    social_engagement: z.object({
      published: z.boolean(),
      tone_of_voice_state: z.enum(AiAutomationTovState).nullable().optional(),
      tone_of_voice_data: z.array(tovSampleSchema).nullable().optional(),
    }),
  }),
})

const statsCounterSchema = z.object({
  total: z.number(),
  unique: z.number(),
})

const aiAutomationStatsSchema = z.object({
  faq: z.object({
    started: statsCounterSchema,
    succeeded: statsCounterSchema,
  }),
  social_engagement: z.object({
    started: statsCounterSchema,
    succeeded: statsCounterSchema,
  }),
})

export const AiAutomationApiSchemas = {
  getConfig: {
    response: z.object({
      config: aiAutomationConfigSchema,
    }),
    query: z.undefined(),
    path: z.undefined(),
  },
  updateConfig: {
    request: z.object({
      config: aiAutomationConfigSchema,
    }),
    response: z.object({
      config: aiAutomationConfigSchema,
    }),
    query: z.object({
      client_id: z.string(),
    }),
    path: z.undefined(),
  },
  getStats: {
    response: z.object({
      stats: aiAutomationStatsSchema,
    }),
    query: z.undefined(),
    path: z.undefined(),
  },
  generateSocialEngagementSamples: {
    response: z.undefined(),
    query: z.undefined(),
    path: z.undefined(),
  },
}

export const AiAutomationSchemas = {
  config: aiAutomationConfigSchema,
  tovSample: tovSampleSchema,
}

export type AiAutomationConfig = z.infer<typeof aiAutomationConfigSchema>
export type AiAutomationStats = z.infer<typeof aiAutomationStatsSchema>
export type FallbackAssignee = z.infer<typeof fallbackAssigneeSchema>
export type TovSample = z.infer<typeof tovSampleSchema>
